const safeParseObjectFromSessionStorage = (key: string) => {
  const nonParsedItemFromSessionStorage = sessionStorage.getItem(key);

  if (typeof nonParsedItemFromSessionStorage === 'string') {
    try {
      return JSON.parse(nonParsedItemFromSessionStorage);
    } catch {
      return null;
    }
  } else {
    return null;
  }
};

export default safeParseObjectFromSessionStorage;
